var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenanceError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 402.964,
    height: 254.59,
    viewBox: "0 0 402.964 254.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8823",
    d: "M0 0H189.941V20.968H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10144",
    d: "M406.953 210.539a6.253 6.253 0 1 0 8.313-3.016 6.252 6.252 0 0 0-8.313 3.016z",
    className: "cls-2",
    transform: "translate(-406.363 -206.933)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10172",
    d: "M509.421 291.132a6.325 6.325 0 1 0 8.9-.887 6.324 6.324 0 0 0-8.9.887z",
    className: "cls-2",
    transform: "translate(-507.99 -288.814)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10180",
    d: "M419.827 367.246l11.441-29.571a1.654 1.654 0 0 1 3.086 0l11.446 29.571z",
    className: "cls-1",
    transform: "translate(-419.827 -336.617)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10182",
    d: "M563.184 367.325l11.442-29.572a1.654 1.654 0 0 1 3.085 0l11.442 29.572z",
    className: "cls-1",
    transform: "translate(-563.184 -336.696)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f5d100}.cls-2{fill:#eb8175}.cls-10,.cls-4{fill:#d5efff}.cls-6{fill:#004d77}.cls-7{fill:#2c72a9}.cls-8{fill:#bed6f6}.cls-9{fill:#151247}.cls-10{opacity:.16}.cls-13{fill:#fff}.cls-14{fill:#14103d}.cls-15{fill:#95646a}.cls-16{fill:#231c61}.cls-17{fill:#e1ad9d}.cls-18{fill:#c8c6f2}.cls-19{fill:#d8d7fd}.cls-20{fill:#091218}.cls-30,.cls-31,.cls-34,.cls-42{fill:none}.cls-30,.cls-31,.cls-34{stroke-miterlimit:10}.cls-42{stroke-linecap:round;stroke-linejoin:round}.cls-25{fill:#334fbe}.cls-30,.cls-31,.cls-34{stroke:#bed6f6;stroke-width:2.649px}.cls-31,.cls-34{stroke:#2c72a9}.cls-34{stroke-width:2.162px}.cls-39{fill:#fafafa}.cls-40{fill:#e8c400}.cls-42{stroke:#e5e5e5;stroke-width:1.137px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11010",
    transform: "translate(-43.566 -183.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11008",
    transform: "translate(43.787 185.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10935",
    transform: "translate(0 5.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10104",
    fill: "#dee5ed",
    d: "M702.911 327.625a85.433 85.433 0 0 0 2.23-43.193c-4.842-22.391-20.442-49.5-65.457-61.194-85.224-22.144-114.814-86.9-194.533-66.28 0 0-42.781 7.774-63.029 78.565s-99.583 72-72.267 133.632c4.465 10.075 16.487 21.065 33.745 31.445l323.291-1.087c22.343-26.86 29.297-50.097 36.02-71.888z",
    opacity: 0.295,
    transform: "translate(-304.194 -152.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10934",
    transform: "translate(57.041 80.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10105",
    d: "M601.484 265.942h-12.13v-13.269A14.045 14.045 0 0 0 578.493 239v-16.467h-4.464v16.155a14.046 14.046 0 0 0-12.774 13.985v13.659h-12.066v15.219h-.812v28.287l-21.931-.158v-33.806h-25.131v24.775h-17.631v24.069h-21.31v63.71h70.8v-.009h15.207v.009h88.774v-80.341h-35.7z",
    className: "cls-4",
    transform: "translate(-336.091 -222.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10106",
    d: "M368.515 296.869V265.2h11.873v-16.942h4.464V265.2h10.938v31.672h12.273v18.974h19.558v-64.64h40.833v133.133H353.411v-87.47z",
    className: "cls-4",
    transform: "translate(-353.411 -218.444)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10942",
    transform: "translate(96.346 112.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10936",
    transform: "translate(0 126.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    fill: "#3a86ba",
    d: "M586.208 367.149l-186.108.145a12.763 12.763 0 0 1-12.774-12.752l211.634-.166a12.762 12.762 0 0 1-12.752 12.773z",
    transform: "translate(-387.326 -354.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    d: "M586.2 362.754l-186.1.146a12.754 12.754 0 0 1-11.977-8.36h-.794a12.763 12.763 0 0 0 12.771 12.754l186.108-.145a12.762 12.762 0 0 0 12.752-12.773h-.793a12.754 12.754 0 0 1-11.967 8.378z",
    className: "cls-6",
    transform: "translate(-387.326 -354.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    d: "M492.89 358.713l-24.045.019a4.273 4.273 0 0 1-4.275-4.27l32.59-.025a4.273 4.273 0 0 1-4.27 4.276z",
    className: "cls-6",
    transform: "translate(-375.047 -354.366)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10938",
    transform: "translate(10.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    d: "M586.588 371.731l-189.851.148-.089-114.592a11.9 11.9 0 0 1 11.893-11.913l166.045-.129a11.9 11.9 0 0 1 11.914 11.894z",
    className: "cls-7",
    transform: "translate(-396.647 -245.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8819",
    d: "M0 0H170.077V106.696H0z",
    className: "cls-8",
    transform: "translate(9.927 9.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8820",
    d: "M0 0H170.078V10.199H0z",
    className: "cls-9",
    transform: "translate(9.964 106.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8821",
    d: "M0 0H170.077V5.063H0z",
    className: "cls-9",
    transform: "translate(9.887 9.964)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10937",
    transform: "translate(9.929 9.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10111",
    d: "M461.892 253.868l-56.677 56.766.039 49.974h.123l106.611-106.779z",
    className: "cls-10",
    transform: "translate(-405.214 -253.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10112",
    d: "M424.2 360.6l25.115-.024L555.924 253.8l-25.115.024z",
    className: "cls-10",
    transform: "translate(-402.197 -253.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10113",
    fill: "#5571e9",
    d: "M540.229 353.8l19.99-20.021-.03-37.881-60 57.926z",
    opacity: 0.16,
    transform: "translate(-390.118 -247.104)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10941",
    transform: "translate(10.802 55.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8822",
    d: "M0 0H189.941V20.968H0z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10940",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10114",
    d: "M419.334 322.018h-16.343l14.067-32.18H433.4z",
    className: "cls-13",
    transform: "translate(-395.638 -293.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10115",
    d: "M449.406 322.018h-16.343l14.068-32.18h16.343z",
    className: "cls-13",
    transform: "translate(-390.858 -293.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10116",
    d: "M479.478 322.018h-16.343l14.067-32.18h16.343z",
    className: "cls-13",
    transform: "translate(-386.078 -293.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10117",
    d: "M509.55 322.018h-16.343l14.067-32.18h16.343z",
    className: "cls-13",
    transform: "translate(-381.298 -293.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10118",
    d: "M539.622 322.018h-16.343l14.068-32.18h16.343z",
    className: "cls-13",
    transform: "translate(-376.517 -293.694)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10963",
    transform: "translate(82.983 63.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10949",
    transform: "translate(0 39.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10944",
    transform: "translate(0 20.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10943",
    transform: "translate(0 7.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10119",
    d: "M384.7 262.018l-3.713.143-2.173-.69a2.361 2.361 0 0 0-2.671.932l-.275.407 10.855 6 2.1-4.5z",
    className: "cls-14",
    transform: "translate(-375.785 -261.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    d: "M386.735 268.809l-10.935-6.043.382-.692a.281.281 0 0 1 .384-.11l10.693 5.906-.519.939",
    className: "cls-14",
    transform: "translate(-375.796 -261.27)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10121",
    d: "M387.609 265.282l2.867-4.963-2.867-5.122-4.122 7.8z",
    className: "cls-15",
    transform: "translate(-374.573 -255.198)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10122",
    d: "M410.2 239.55s-15.47-4.439-16.959-.262-10.514 22.655-10.514 22.655l6.736 3.514 10.1-17.547 13.595-1.183z",
    className: "cls-14",
    transform: "translate(-374.695 -237.497)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10948",
    transform: "translate(15.686 1.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10947",
    transform: "translate(0 23.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10946",
    transform: "translate(0 8.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10123",
    d: "M396.565 266.787l-3.028 1.93-2.234.451a2.36 2.36 0 0 0-1.886 2.11l-.043.488 12.4-.019-.348-4.956z",
    className: "cls-14",
    transform: "translate(-389.324 -266.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10124",
    d: "M401.83 271.284l-12.5.019v-.79a.282.282 0 0 1 .283-.283l12.215-.02v1.074",
    className: "cls-14",
    transform: "translate(-389.331 -266.243)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10125",
    d: "M400.441 268.008l.4-8.314-4.939-.557-.323 8.863z",
    className: "cls-15",
    transform: "translate(-388.338 -259.137)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10126",
    d: "M410.5 238.655l-14.58.664s-2.1.116-1.956 5.024.128 24.66.128 24.66l7 .242 1.341-20.69 14.594-.18a7.852 7.852 0 0 0 7.155-4.628 5.715 5.715 0 0 0 .4-3.566z",
    className: "cls-16",
    transform: "translate(-388.595 -238.655)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10956",
    transform: "translate(13.015 17.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10951",
    transform: "translate(5.731 .189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10950",
    transform: "translate(0 18.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    d: "M396.981 236.461c0 1.384-.935 1.594-2.319 1.6s-2.689-.2-2.691-1.585a2.505 2.505 0 1 1 5.01-.01z",
    className: "cls-17",
    transform: "translate(-391.971 -233.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    d: "M398.4 237.715l-2.9.006a1.378 1.378 0 0 1-1.378-1.372 1.379 1.379 0 0 1 1.372-1.378l2.9-.006a1.379 1.379 0 0 1 1.378 1.372 1.379 1.379 0 0 1-1.372 1.378z",
    className: "cls-17",
    transform: "translate(-391.629 -233.801)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10129",
    d: "M397.849 240.7l-.967-4.739 11.9-1.3 2.382-13.908c.24-1.264 2.07-2.832 3.334-2.593l-.364-.1a2.836 2.836 0 0 1 2.185 2.973l-2.317 16.637a2.331 2.331 0 0 1-1.737 1.83z",
    className: "cls-18",
    transform: "translate(-391.19 -218.058)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    d: "M419.824 218.494a2.535 2.535 0 0 1 .715.165l.119.046a5.876 5.876 0 0 1 3.52 5.045l-1.86 19.732c-12.334-.107-14.086-1.528-14.086-1.528l.98-20.186c.149-1.9 1.023-3.695 3.192-3.874z",
    className: "cls-19",
    transform: "translate(-383.655 -217.895)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10954",
    transform: "translate(17.581 2.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10952",
    transform: "translate(0 17.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    d: "M407.2 237.777c.1 1.38-.828 1.651-2.208 1.745s-2.7-.022-2.791-1.4a2.505 2.505 0 1 1 5-.343z",
    className: "cls-15",
    transform: "translate(-402.196 -235.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    d: "M408.708 238.95l-2.888.2a1.379 1.379 0 0 1-1.467-1.277 1.38 1.38 0 0 1 1.278-1.466l2.888-.2a1.378 1.378 0 0 1 1.466 1.277 1.378 1.378 0 0 1-1.277 1.466z",
    className: "cls-15",
    transform: "translate(-401.853 -235.322)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10133",
    d: "M408.205 241.766l-1.278-4.665 12.972-2.085-.737-12.062c.155-1.277 1.555-2.713 2.832-2.558a2.836 2.836 0 0 1 2.378 2.821l.934 14.452a2.33 2.33 0 0 1-1.612 1.941z",
    className: "cls-19",
    transform: "translate(-401.444 -220.384)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10955",
    transform: "translate(0 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10134",
    d: "M388.813 225.006l14.154 1.334a.992.992 0 0 1 .891.872l1.485 12.754a.991.991 0 0 1-1.077 1.1l-14.388-1.357a.99.99 0 0 1-.894-.889l-1.249-12.732a.989.989 0 0 1 1.078-1.082z",
    className: "cls-20",
    transform: "translate(-386.914 -224.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10135",
    fill: "#1b2934",
    d: "M388.11 224.94l14.154 1.334a.989.989 0 0 1 .89.872l1.486 12.754a.991.991 0 0 1-1.077 1.1l-14.39-1.357a.991.991 0 0 1-.892-.889l-1.251-12.732a.99.99 0 0 1 1.08-1.082z",
    transform: "translate(-387.026 -224.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10136",
    d: "M402.682 237.989l9.672.912a.537.537 0 0 1 .483.584.536.536 0 0 1-.584.483L402 239.039z",
    className: "cls-20",
    transform: "translate(-384.646 -222.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10137",
    d: "M395.385 231.848a1.549 1.549 0 1 1-1.4-1.689 1.551 1.551 0 0 1 1.4 1.689z",
    className: "cls-13",
    transform: "translate(-386.189 -224.106)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10138",
    d: "M418.711 225l.319 9.069-12.1 2.3 10.665-3.331z",
    className: "cls-18",
    transform: "translate(-383.862 -216.765)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10962",
    transform: "translate(33.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10960",
    transform: "translate(1.786 4.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10139",
    d: "M411.556 217.749l.809 2.172a2.129 2.129 0 0 0 1.85 1.379 2.127 2.127 0 0 0 2.1-2.955l-1.415-3.335z",
    className: "cls-15",
    transform: "translate(-405.537 -205.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10140",
    d: "M412.306 219.867s3.986-.753 3.4-4.238-4.335-.766-4.335-.766l.365 3.479z",
    className: "cls-15",
    transform: "translate(-405.567 -205.833)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10141",
    d: "M406.953 210.539a6.253 6.253 0 1 0 8.313-3.016 6.252 6.252 0 0 0-8.313 3.016z",
    className: "cls-15",
    transform: "translate(-406.363 -206.933)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10957",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10142",
    d: "M415.182 214.783s-.984 5.01 2.7 5.119 1.677-9.4 1.677-9.4l-5.826-5.864-8.916 2.2.884 5.765s1.417.752 9.083-.511z",
    className: "cls-16",
    transform: "translate(-406.609 -207.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10143",
    d: "M410.621 210.011l2.929 4.284 2.525-2.79z",
    className: "cls-16",
    transform: "translate(-405.686 -206.444)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10145",
    d: "M412.934 212.53a1.768 1.768 0 1 0 2.35-.853 1.768 1.768 0 0 0-2.35.853z",
    className: "cls-15",
    transform: "translate(-405.345 -206.205)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10146",
    d: "M405.862 212.767s-1.351-4.929 1.844-7.979a6.411 6.411 0 0 1 9.282.44 9.829 9.829 0 0 1 2.063 6.256z",
    className: "cls-1",
    transform: "translate(-404.702 -203.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10147",
    fill: "none",
    stroke: "#f1ab00",
    strokeMiterlimit: 10,
    strokeWidth: "0.28px",
    d: "M406.414 211.981l-.038-3.077a1.449 1.449 0 0 1 1.38-1.465 1.448 1.448 0 0 1 1.509 1.3l.308 3.07",
    transform: "translate(-404.575 -202.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2975",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.121px",
    d: "M14.349 0L0 1.377",
    transform: "translate(0 8.473)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10986",
    transform: "translate(206.754 152.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10968",
    transform: "translate(10.467 51.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10965",
    transform: "translate(21.747 4.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10148",
    d: "M530.415 353.776l3.216 3.116-3.667 1.972-3.141-3.077z",
    className: "cls-15",
    transform: "translate(-507.774 -323.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10149",
    d: "M510.387 334.6l2.15 9.513a15.114 15.114 0 0 0 2.447 5.411l14.148 12.711 5.6-4.558-12.084-12.797-4.426-16.87z",
    className: "cls-14",
    transform: "translate(-510.387 -328.01)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10964",
    transform: "translate(19.159 31.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10150",
    d: "M529.842 358.507l-1.159 3.7-1.323 1.843a2.349 2.349 0 0 0 .055 2.815l.3.385 9.027-8.412-3.609-3.377z",
    className: "cls-14",
    transform: "translate(-526.918 -355.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10151",
    d: "M536.82 358.5l-9.1 8.478-.728-.782 9.1-8.478.728.781",
    className: "cls-14",
    transform: "translate(-526.906 -355.098)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10152",
    d: "M503.962 358.911l-1.207 4.029-4.143-1.111 1.212-3.956z",
    className: "cls-15",
    transform: "translate(-490.512 -319.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10153",
    d: "M509.613 324.537l-11.606 39.23 7.323 1.829 6.533-19.666 8.025-12.868a17.714 17.714 0 0 0 1.147-1.8 7.6 7.6 0 0 0 .918-3.748l-.028-2.551z",
    className: "cls-16",
    transform: "translate(-490.608 -324.537)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10966",
    transform: "translate(0 42.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10154",
    d: "M499.954 360.952l-3.661 1.352-2.284.079a2.366 2.366 0 0 0-2.211 1.777l-.122.476 12.265 2.018.471-4.957z",
    className: "cls-14",
    transform: "translate(-491.614 -360.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10155",
    d: "M503.985 366.372l-12.362-2.034.175-1.062 12.362 2.034-.175 1.062",
    className: "cls-14",
    transform: "translate(-491.623 -360.582)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10156",
    d: "M494.689 290.156L490 297.474l2.248 1.614 4.855-7.743z",
    className: "cls-25",
    transform: "translate(-481.414 -278.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10157",
    fill: "#4265d1",
    d: "M489.774 279.692s2.167 9.07 13.15 12.642a.864.864 0 0 1 .6.7 3.324 3.324 0 0 1-2.288 3.994.876.876 0 0 1-.687-.109c-1.678-1.051-9.941-5.882-17.96-4.489z",
    transform: "translate(-482.591 -279.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10158",
    d: "M489.774 279.692s-2.013 9.048-7.183 12.737c0 0 .729-7.934 7.183-12.737z",
    className: "cls-25",
    transform: "translate(-482.591 -279.692)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10972",
    transform: "translate(7.003 16.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10159",
    d: "M488.686 296.4a3.718 3.718 0 0 0 2.7 4.037 3.077 3.077 0 0 0 3.631-2.4 3.721 3.721 0 0 0-2.7-4.037 3.077 3.077 0 0 0-3.631 2.4z",
    className: "cls-15",
    transform: "translate(-488.634 -293.937)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10160",
    d: "M497.02 300.744l-3.252-3.4-2.124 2.614 5.376 3.941",
    className: "cls-15",
    transform: "translate(-488.155 -293.395)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10161",
    d: "M496.309 297.568l-3.437 5.11 9.4 8.6a4.967 4.967 0 0 0 1.766.17l12.41-1.609a3.545 3.545 0 0 0 3.373-3.709c-.093-1.955.283-4.785-1.674-4.693l-14.42 2.963z",
    className: "cls-18",
    transform: "translate(-487.96 -293.359)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10975",
    transform: "translate(28.698 24.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10162",
    d: "M521.838 308.765a7.126 7.126 0 0 0-3.2-6.868 4.583 4.583 0 0 0-2.8-.984c-2.474.417-5.019 1.539-6.108 4.88-1.852 5.682-2.382 22.476-2.382 22.476l13.3.454z",
    className: "cls-19",
    transform: "translate(-507.353 -300.892)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10163",
    d: "M515.615 308.05l4 14.7.808-12.47z",
    className: "cls-18",
    transform: "translate(-506.04 -299.754)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10978",
    transform: "translate(35.617 26.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10977",
    transform: "translate(12.924 24.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10976",
    transform: "translate(.888 5.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10164",
    d: "M530.387 333.879a3.719 3.719 0 0 0 .206-4.85 3.076 3.076 0 0 0-4.346-.206 3.72 3.72 0 0 0-.207 4.85 3.078 3.078 0 0 0 4.347.206z",
    className: "cls-15",
    transform: "translate(-525.24 -328.022)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10165",
    d: "M524.474 324.211l2.425 5.984 3.257-.856-2.014-6.354",
    className: "cls-15",
    transform: "translate(-524.474 -322.985)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10166",
    d: "M526.4 332.133l6.661-1.464-4.518-15.45a4.946 4.946 0 0 0-.8-1.587l-8.292-10.323c-1.121-1.606-3.011-1.319-4.616-.2a3.546 3.546 0 0 0-.878 4.936l7.987 9.6z",
    className: "cls-19",
    transform: "translate(-513.323 -302.188)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10985",
    transform: "translate(28.07 6.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10983",
    transform: "translate(1.366 4.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10167",
    d: "M511.991 299.42l.253 2.329a2.15 2.15 0 0 0 1.469 1.811 2.151 2.151 0 0 0 2.8-2.372l-.561-3.623z",
    className: "cls-15",
    transform: "translate(-507.354 -287.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10168",
    d: "M512.209 301.747s4.109-.134 4.4-3.7-4.073-1.442-4.073-1.442l-.508 3.5z",
    className: "cls-15",
    transform: "translate(-507.348 -287.675)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10169",
    d: "M509.421 291.132a6.325 6.325 0 1 0 8.9-.887 6.324 6.324 0 0 0-8.9.887z",
    className: "cls-15",
    transform: "translate(-507.99 -288.814)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10980",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10170",
    d: "M516.344 297.235s-2.212 4.665 1.37 5.689 3.984-8.793 3.984-8.793l-4.252-7.2-9.287-.068-.568 5.871s1.2 1.091 9.031 1.762z",
    className: "cls-16",
    transform: "translate(-508.054 -289.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10171",
    d: "M512.908 291.715l1.8 4.929 3.17-2.106z",
    className: "cls-16",
    transform: "translate(-507.208 -288.353)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10173",
    d: "M514.616 294.707a1.788 1.788 0 1 0 2.516-.25 1.788 1.788 0 0 0-2.516.25z",
    className: "cls-15",
    transform: "translate(-507.001 -287.982)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10174",
    d: "M507.82 293.541s-.311-5.159 3.488-7.511a6.485 6.485 0 0 1 9.1 2.371 9.942 9.942 0 0 1 .736 6.621z",
    className: "cls-1",
    transform: "translate(-506.652 -285.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10175",
    fill: "none",
    stroke: "#f1ab00",
    strokeMiterlimit: 10,
    strokeWidth: "0.283px",
    d: "M508.413 293.011l.6-3.053a1.466 1.466 0 0 1 1.672-1.161 1.464 1.464 0 0 1 1.222 1.6l-.335 3.1",
    transform: "translate(-506.557 -284.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2976",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.133px",
    d: "M14.488 1.63L0 0",
    transform: "translate(0 8.333)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10997",
    transform: "translate(173.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10987",
    transform: "translate(141.532 48.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_2977",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 157.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2978",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 142.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2979",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 126.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2980",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 110.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2981",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 94.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2982",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 78.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2983",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 63.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2984",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 47.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2985",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 31.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2986",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727 15.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2987",
    d: "M14.99 0L0 14.778",
    className: "cls-30",
    transform: "translate(7.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2988",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 156.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2989",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 141.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2990",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 125.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2991",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 109.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2992",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 93.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2993",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 77.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2994",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 62.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2995",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 46.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2996",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 30.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2997",
    d: "M0 0L14.99 0",
    className: "cls-30",
    transform: "translate(7.727 14.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2998",
    d: "M0 174.451L0 0",
    className: "cls-31",
    transform: "translate(7.727 2.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2999",
    d: "M0 174.451L0 0",
    className: "cls-31",
    transform: "translate(22.718 2.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8824",
    d: "M0 0H29.852V31.016H0z",
    className: "cls-6",
    transform: "translate(0 172.697)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10988",
    transform: "translate(143.703 21.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8825",
    fill: "#cbcbdd",
    d: "M4.3 0h16.971a4.3 4.3 0 0 1 4.3 4.3v20.938a4.3 4.3 0 0 1-4.3 4.3H4.3a4.3 4.3 0 0 1-4.3-4.3V4.3A4.3 4.3 0 0 1 4.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8826",
    fill: "#e5e5e5",
    d: "M0 0h10.561a3.259 3.259 0 0 1 3.259 3.259v7.3a3.259 3.259 0 0 1-3.259 3.259H0V0z",
    transform: "translate(2.33 7.122)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10991",
    transform: "translate(0 48.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3000",
    d: "M0 0L11.991 34.835",
    className: "cls-34",
    transform: "translate(50.361 4.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3001",
    d: "M23.384 0L0 31.584",
    className: "cls-34",
    transform: "translate(18.635)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10990",
    transform: "translate(0 9.202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8827",
    width: 55.628,
    height: 55.628,
    className: "cls-1",
    rx: 6.838,
    transform: "scale(-1) rotate(52.6 62.025 -73.214)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8828",
    width: 45.514,
    height: 45.514,
    fill: "none",
    stroke: "#2e2d3b",
    strokeMiterlimit: 10,
    strokeWidth: "1.114px",
    rx: 5.595,
    transform: "scale(-1) rotate(52.6 54.377 -70.624)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10989",
    transform: "translate(33.882 23.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10176",
    d: "M490.284 245.215c-.626 4.691-7.744 3.742-7.119-.949.635-4.733 7.749-3.784 7.119.949zm3.062-26.209l-2.793 19.717-5.987-.8c.884-6.633 1.621-13.08 2.511-19.754z",
    className: "cls-7",
    transform: "translate(-483.126 -218.171)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10994",
    transform: "translate(36.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10992",
    transform: "translate(0 35.287)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2088",
    cx: 10.025,
    cy: 10.025,
    r: 10.025,
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10177",
    d: "M502.453 188.176a7.089 7.089 0 1 1-7.088-7.088 7.088 7.088 0 0 1 7.088 7.088z",
    className: "cls-6",
    transform: "translate(-485.339 -178.152)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10993",
    transform: "translate(10.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3002",
    d: "M0 0L0 21.249",
    className: "cls-30",
    transform: "translate(39.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3003",
    d: "M0 0L0 21.249",
    className: "cls-30",
    transform: "translate(20.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3004",
    d: "M0 0L0 21.249",
    className: "cls-30",
    transform: "translate(58.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3005",
    d: "M0 0L0 21.249",
    className: "cls-30",
    transform: "translate(79.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3006",
    d: "M0 0L0 21.249",
    className: "cls-30",
    transform: "translate(99.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3007",
    d: "M0 0L0 21.249",
    className: "cls-30",
    transform: "translate(119.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3008",
    d: "M0 0L0 21.249",
    className: "cls-30",
    transform: "translate(139.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3009",
    d: "M0 21.249L20.048 0",
    className: "cls-30",
    transform: "translate(19.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3010",
    d: "M0 21.249L20.048 0",
    className: "cls-30",
    transform: "translate(39.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3011",
    d: "M0 21.249L20.048 0",
    className: "cls-30",
    transform: "translate(59.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3012",
    d: "M0 21.249L20.048 0",
    className: "cls-30",
    transform: "translate(79.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3013",
    d: "M0 21.249L20.048 0",
    className: "cls-30",
    transform: "translate(99.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3014",
    d: "M0 21.249L20.048 0",
    className: "cls-30",
    transform: "translate(119.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10178",
    fill: "none",
    stroke: "#2c72a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.649px",
    d: "M494.392 169.357h163.456l-22.008-21.25H511.3z",
    transform: "translate(-494.392 -148.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3015",
    fill: "none",
    stroke: "#5571e9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.649px",
    d: "M0 0L0 24.062",
    transform: "translate(0 21.249)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11004",
    transform: "translate(131.922 218.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10999",
    transform: "translate(2.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10179",
    d: "M419.827 367.246l11.441-29.571a1.654 1.654 0 0 1 3.086 0l11.446 29.571z",
    className: "cls-1",
    transform: "translate(-419.827 -336.617)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10998",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8829",
    d: "M0 0H20.315V6.276H0z",
    className: "cls-39",
    transform: "translate(2.65 7.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8830",
    d: "M0 0H22.977V6.276H0z",
    className: "cls-39",
    transform: "translate(1.541 19.277)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8831",
    d: "M0 0H30.283V2.492H0z",
    className: "cls-40",
    transform: "translate(0 30.629)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11003",
    transform: "translate(166.145 .091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11002",
    transform: "translate(2.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10181",
    d: "M563.184 367.325l11.442-29.572a1.654 1.654 0 0 1 3.085 0l11.442 29.572z",
    className: "cls-1",
    transform: "translate(-563.184 -336.696)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11001",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8832",
    d: "M0 0H20.315V6.276H0z",
    className: "cls-39",
    transform: "translate(2.651 7.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8833",
    d: "M0 0H22.977V6.276H0z",
    className: "cls-39",
    transform: "translate(1.541 19.277)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8834",
    d: "M0 0H30.283V2.492H0z",
    className: "cls-40",
    transform: "translate(0 30.629)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11007",
    transform: "translate(.347 172.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11006",
    transform: "translate(44.518)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2089",
    cx: 23.761,
    cy: 23.761,
    r: 23.761,
    className: "cls-8",
    transform: "rotate(-81.529 27.261 23.502)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11005",
    transform: "translate(17.762 18.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3016",
    d: "M0 0L0 60.388",
    className: "cls-42",
    transform: "translate(9.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3017",
    d: "M0 0L9.24 10.362",
    className: "cls-42",
    transform: "translate(0 1.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10183",
    d: "M374.4 322.6c-.662.662-8.2 8.508-8.2 8.508",
    className: "cls-42",
    transform: "translate(-356.965 -311.578)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_3018",
    fill: "none",
    stroke: "#3d5ac4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.137px",
    d: "M0 0L398.568 0",
    transform: "translate(0 79.502)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceError);
export default __webpack_public_path__ + "static/media/MaintenanceError.476c35741309dea89fdf13057e2c8e2a.svg";
export { ForwardRef as ReactComponent };